/*
Author: Vaishnavi
Date: 19/11/2019
Issue Description: Removed exclaamtion icon before Error Message
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: Added readonly mode.
search_string: readonly
*/

/*
Author: Vinod
Date: 10/03//2020
Issue Description: Browser suggestions as to be removed.
search_string: PL_2909
*/
<template>
  <div class="tl-textfield">
    <div class="input-container">
      <div v-show="!!label" class="input-label">{{label}}</div>
      <div v-if="type==='textarea'">
        <textarea
          autofocus
          :rows="rows"
          :value="value"
          :name="name"
          :maxlength="maxlength"
          v-validate="validations"
          :placeholder="placeholder"
          :data-vv-name="name"
          @blur="$emit('blur')"
          @input="handleInput"
          @keyup.enter="$emit('onValueChange')"
          :class="{'errorr': classname}"
          :disabled="disable"
        />
      </div>
      <div v-else>
        <!-- PL_2909(Added autocomplete off) -->
        <input
          class="inputField"
          :type="type"
          :value="value"
          :name="name"
          :maxlength="maxlength"
          v-validate="validations"
          :placeholder="placeholder"
          :data-vv-name="name"
          @input="handleInput"
          @blur="$emit('blur')"
          @keyup.enter="$emit('onValueChange')"
          :class="{'errorr': classname}"
          :autofocus="autofocus"
          autocomplete="off"
          :disabled="disable"
          :readonly="readonly"
        />
        <br />
      </div>
      <span class="errorMessage" v-show="classname">
        <span class="error">{{errormsg}}</span>
      </span>
      <!-- <div v-if="errors.has(name)" class="row-align">
        <div class="icon"></div>
        <span class="alert-danger">
          {{ errors.first(name) }}
        </span>
      </div>-->
    </div>
  </div>
</template>
<script>
import {
  isValidEmail,
  isValidPassword,
  isValidNumber,
  isValidString
} from "@/utils/validations.js";

export default {
  name: "textfield",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    name: String,
    rows: String,
    type: String,
    label: String,
    hint: String,
    maxlength: {
      type: String
    },
    // max: {
    //   type:Number
    // },
    value: [String, Number],
    validations: {
      type: Object | String
    },
    classname: Boolean,
    placeholder: {
      type: String
    },
    autofocus: {
      type: Boolean,
      default: true
    },
    errormsg: String,
    disable: Boolean,
    // Start readonly
    readonly: {
      type: Boolean,
      default: false
    }
    // End readonly
  },
  data() {
    return {
      focused: false
    };
  },
  computed: {
    hasLabel: {
      get() {
        return this.label != null && this.label != "";
      }
    }
  },
  methods: {
    checkValid(e) {
      var value = e.target.value;
      //console.log(e.target.type);
      //if (!isEmpty(str)) {
      switch (e.target.type) {
        case "email":
          this.hint = isValidEmail(value);
          break;
        case "password":
          //return isValidPassword(value);
          this.hint = isValidPassword(value);
          break;
        case "number":
          //return isValidNumber(value);
          this.hint = isValidNumber(value);
          // this.max=6
          break;
        case "text":
          //return isValidNumber(value);
          this.hint = isValidString(value);
          break;
        case "alphabet":            
            const regex = /^[A-Za-z\s]*$/;
            this.hint = regex.test(value) ? '' : 'Only alphabets are allowed';
            break;
      }
      //}
    },
  handleInput(e) {
    
    let value = e.target.value;
    value = value.replace(/<[^>]*>/g, "")
      if (this.type === "number") {
        value = Number(value);
      } else if (this.type === "alphabet") {
        
        const regex = /^[A-Za-z\s]*$/;
        value = value.replace(/[^A-Za-z\s]/g, '');
        e.target.value = value;

      }

      this.$emit("change", value);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/tl-textfield.scss";
@import "@/scss/_variables.scss";
.row-align {
  display: flex;
  margin-left: 2px;
  margin-top: 5px;
}
.imgClass {
  padding-top: 0px;
  float: left;
  margin-right: 5px;
}
.label {
  color: #000000;
  font-size: 14px;
  width: 224px;
  height: 18px;
  font-family: Montserrat;
}
.icon {
  background-image: url("../../assets/error.svg");
  height: 14px;
  width: 14px;
}
.alert-danger {
  color: #a41010;
  font-size: 12px;
  margin-left: 5px;
}
.errorr {
  border-color: #a41010;
}
.errorMessage {
  color: #e01717;
  .error {
    margin-top: 2px;
  }
}
.inputField::-webkit-inner-spin-button,
.inputField::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
